import React from "react";
import Carousel from "theme/components/organisms/Carousel";
import PropTypes from "prop-types";

/** @type {React.FunctionComponent<SliderProps>} */
const Slider = ({
  children,
  data,
  className = "",
  "data-pb-style": styleId,
}) => {
  return (
    <div className={className} data-pb-style={styleId}>
      <Carousel showNavigation={data.showDots} showControls={data.showArrows}>
        {children}
      </Carousel>
    </div>
  );
};

/** @typedef {PropTypes.InferProps<typeof propTypes>} SliderProps */
const propTypes = {
  data: PropTypes.shape({
    showDots: PropTypes.bool,
    showArrows: PropTypes.bool,
  }),
  className: PropTypes.string,
  "data-pb-style": PropTypes.string,
};
Slider.propTypes = propTypes;

export default Slider;
